import { useState } from 'react';
import { useViewport } from '@tryhackme/thm-ui-components';

import { BREAKPOINTS } from 'src/common/constants/breakpoints';

export const useRoadmapHook = () => {
  const [selectedOption, setSelectedOption] = useState<{ value: string; label: string }>();

  const { width } = useViewport();
  const isMobile = width < BREAKPOINTS.MOBILE;

  const arrowStyle = {
    style: {
      endShape: {
        arrow: { arrowLength: 6.5, arrowThickness: 6.5 },
      },
    },
  };

  return { isMobile, arrowStyle, selectedOption, setSelectedOption };
};
